import { Box, Typography } from "@mui/material";
import { observer } from "mobx-react-lite";
import InfoIcon from "../../../../assets/images/icons/InfoIcon";
import BriaTooltip from "../../BriaTooltip/BriaTooltip";
import BriaSwitch from "../BriaSwitch";
import styles from "./ConfigSwitch.module.scss";

type ConfigSwitchProps = {
	label: string;
	info?: React.ReactNode;
	checked: boolean;
	onChange: (checked: boolean) => void;
	className?: string;
	disabled?: boolean;
};

const ConfigSwitch = ({ label, info, checked, onChange, className, disabled }: ConfigSwitchProps) => (
	<Box className={`${styles.configSwitchContainer} ${className ?? ""}`}>
		<Box className={styles.configSwitchTextContainer}>
			<Typography className={styles.configSwitchLabel}>{label}</Typography>
			{info && (
				<BriaTooltip title={info} className={styles.info} displayOn="click">
					<InfoIcon className={styles.infoIcon} />
				</BriaTooltip>
			)}
		</Box>
		<BriaSwitch
			checked={checked}
			onToggle={onChange}
			disabled={disabled}
			disabledTooltip={disabled && info ? (info as string) : undefined}
		/>
	</Box>
);

export default observer(ConfigSwitch);
